import { CreateActionParams } from '../actions';
import { bookingsBookingsFormLoad } from '@wix/bi-logger-wixboost-ugc/v2';
import {
  bookingsUoUBookTwiceModalLoadClicksSrc16Evid1151,
  bookingsUoUFlowSlotSelectionCompletedSrc16Evid34,
  bookingsUoUFlowWidgetLoadSrc16Evid32,
} from '@wix/bi-logger-bookings-data/v2';
import { FormStatus } from '../../../../types/form-state';
import {
  DoubleBookingActions,
  DoubleBookingComponents,
  DoubleBookingModalTypes,
  ReferralInfo,
} from '../../../../types/biLoggerTypes';
import { FormState, SlotService } from '../../../../utils/state/types';
import { createInitialState } from '../../../../utils/state/initialStateFactory';
import { WIDGET_NAME } from '../../../../utils/bi/consts';
import { mapToArray } from '../../../../utils';
import { canCompleteBoooking } from '../../../../utils/validations/canBook';

export type InitializeWidget = () => void;

export function createInitializeWidgetAction({
  flowApi,
  getControllerState,
  internalActions: { calculatePaymentDetails },
  context: {
    biLogger,
    formApi,
    reportError,
    wixSdkAdapter,
    t,
    bookingsDataCapsule,
  },
}: CreateActionParams): InitializeWidget {
  return async () => {
    const [state, setState] = getControllerState();

    try {
      const initialState: FormState = await createInitialState({
        currentState: state,
        wixSdkAdapter,
        bookingsDataCapsule,
        flowApi,
        formApi,
        t,
        reportError,
      });
      const { isCart, isServiceInCart, serviceData } = initialState;

      if (initialState?.errors?.length) {
        console.error(initialState.errors[0]);
      }

      if (!serviceData) {
        console.error(initialState.errors[0]);
        setState({
          ...initialState,
          status: FormStatus.IDLE,
        });

        return;
      }

      setState({
        ...initialState,
      });

      biLogger?.initialDefaultBiLogger(initialState);

      biLogger?.report(
        bookingsBookingsFormLoad({
          formId: serviceData.formId,
          ...(isCart
            ? {
                ...(isServiceInCart
                  ? { referralInfo: ReferralInfo.AddMoreSessions }
                  : {}),
                emptyCart: !isServiceInCart,
              }
            : {}),
          numberOfServices: Object.keys(serviceData.slotServices).length,
        }),
      );

      biLogger?.report(
        bookingsUoUFlowWidgetLoadSrc16Evid32({ widget_name: WIDGET_NAME }),
      );

      const firstSlotService = mapToArray<SlotService>(
        state.serviceData.slotServices,
      )[0];

      biLogger?.report(
        bookingsUoUFlowSlotSelectionCompletedSrc16Evid34({
          bookingsServiceId: firstSlotService.service.id,
          endTime: new Date(firstSlotService.nestedSlot.endDate).getUTCDate(),
          startTime: new Date(
            firstSlotService.nestedSlot.startDate,
          ).getUTCDate(),
          serviceType: firstSlotService.service.type,
          isEligibleForFlowCompletion: await canCompleteBoooking({
            formApi,
            isDayful: !!state.isDayful,
            wixSdkAdapter,
            serviceData: state.serviceData,
            activeFeatures: state.businessInfo.activeFeatures!,
            shouldDoActions: false,
          }),
        }),
      );

      setState({
        status: FormStatus.IDLE,
      });

      await calculatePaymentDetails({});

      const existingBooking = await formApi.getExistingBooking({
        slotServices: initialState.serviceData.slotServices,
        contactId: state.memberDetails?.contactId,
      });

      if (existingBooking) {
        setState({
          existingBookingDetails: existingBooking,
        });

        const isMember = !!state.memberDetails?.contactId;

        biLogger?.report(
          bookingsUoUBookTwiceModalLoadClicksSrc16Evid1151({
            component: DoubleBookingComponents.Modal,
            action: DoubleBookingActions.Load,
            modalType: isMember
              ? DoubleBookingModalTypes.Member
              : DoubleBookingModalTypes.Visitor,
          }),
        );
      }
    } catch (e) {
      console.error(e);
      setState({
        status: FormStatus.IDLE,
      });
    }
  };
}
